/* eslint-disable */
import * as util from "@/api/referral";

const state = {
    isJoin: false,

};

const mutations = {
    SET_isJoin: (state, value) => {
        state.isJoin = value
    },
};

const actions = {
    withdrawList({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.withdrawList(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getBalance() {
        return new Promise((resolve, reject) => {
            util.getBalance().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    images() {
        return new Promise((resolve, reject) => {
            util.images().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detail({ commit }, code) {
        return new Promise((resolve, reject) => {
            util.detail(code).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    statThisMonth() {
        return new Promise((resolve, reject) => {
            util.statThisMonth().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    statLastMonth() {
        return new Promise((resolve, reject) => {
            util.statLastMonth().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    memberList({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.memberList(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    orderList({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.orderList(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    shareLink() {
        return new Promise((resolve, reject) => {
            util.shareLink().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    info() {
        return new Promise((resolve, reject) => {
            util.info().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    join() {
        return new Promise((resolve, reject) => {
            util.join().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    check({ commit }) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.check().then(response => {
                const { data } = response;
                commit("SET_isJoin", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/referral.js